import { atom } from "recoil";

const appStore = atom({
    key: "appStore",
    default: false,
});

export default appStore